module.exports = __webpack_public_path__ + "static/img/709bf22738ac678eb9c72cd33870ad48.3d833f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/709bf22738ac678eb9c72cd33870ad48.png
// module id = vZTw
// module chunks = 0